import { appConfig } from '../../../config/customization';
import { small } from '../../../constants/fonts';

const grid = {
  borderWidth: 1,
  borderColor: appConfig.colors.tableBorderColor,
  borderTopStyle: 'solid',
  outline: 0
};

export default {
  header: {
    display: 'flex',
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontWeight: 500,
    flex: 1,
    margin: '0px 5px',
    fontSize: small
  },
  headerRow: {
    boxSizing: 'border-box',
    backgroundColor: appConfig.colors.tableHeaderBackground,
    color: appConfig.colors.tableHeaderText
  },
  container: {
    width: '100%',
    overflow: 'hidden',
    height: '100%'
  },
  gridWithoutScroll: {
    ...grid,
    overflowY: 'hidden',
    height: '100%'
  },
  gridWithScroll: {
    ...grid
  },
  row: {
    height: 50,
    fontSize: small,
    color: appConfig.colors.rowText,
    outline: 0,
    borderTop: `1px solid ${appConfig.colors.accountTableUnderline}`,
    textTransform: 'uppercase'
  },
  oddRow: {
    backgroundColor: appConfig.colors.oddRowColor
  },
  evenRow: {
    backgroundColor: appConfig.colors.evenRowColor
  },
  openableRow: {
    cursor: 'pointer'
  },
  column: {
    display: 'flex',
    boxSizing: 'border-box',
    flex: 1,
    margin: '0px 5px',
    whiteSpace: 'pre-wrap',
    justifyContent: 'center',
    textTransform: 'uppercase'
  },
  activeRowOpenable: {
    position: 'absolute',
    transition: 'max-height 300ms ease'
  },
  columnLeft: {
    justifyContent: 'flex-start'
  },
  headerLeft: {
    justifyContent: 'flex-start'
  },
  listArrow: {
    flexShrink: 0
  }
};
